module.exports = __webpack_public_path__ + "sunsemweb/img/bigc.dcaa91f3.png";